"use client";

import {
  Disclosure,
  DisclosureContent,
  DisclosureTrigger,
} from "./core/disclosure";

export function ContactFaq({ items }: { items: string[][] }) {
  return (
    <div className="faq-list">
      {items.map(([question, answer]) => (
        <Disclosure
          className="faq-item"
          key={question}
          transition={{ type: "spring", stiffness: 220, damping: 24 }}
          variants={{
            expanded: { opacity: 1, scale: 1 },
            collapsed: { opacity: 0, scale: 0.7 },
          }}
        >
          <DisclosureTrigger>
            <button type="button">{question}</button>
          </DisclosureTrigger>
          <DisclosureContent className="faq-content">
            <p>{answer}</p>
          </DisclosureContent>
        </Disclosure>
      ))}
    </div>
  );
}
